import { ON_UNREAD_COUNT_CHANGE_EVENT_TYPE } from 'core/constants';
import { runListenersForEvent } from 'core_main/globals/events';
import { OnUnreadCountChangeCallbackResponse } from 'core_main/pubnub/types';
import { getUnreadCountsFromStore } from 'core_main/store';

export const validateMarkReadParams = (sessionId: string) => {
  if (!sessionId) {
    return new Error('A conversationId must be provided.');
  }

  return undefined;
};

export const runListenersForOnUnreadCountChangeEvent = (sessionId) => {
  const unreadCounts = getUnreadCountsFromStore();

  const callbackResponse: OnUnreadCountChangeCallbackResponse = {
    total: unreadCounts.total,
    change: {
      conversationId: sessionId,
      count: unreadCounts.conversations[sessionId],
    },
  };

  runListenersForEvent(ON_UNREAD_COUNT_CHANGE_EVENT_TYPE, callbackResponse);
};
